module.exports = __webpack_public_path__ + "img/22_55.a91a9358.png";